import { render } from "./SendTestModal.vue?vue&type=template&id=0d5adfe1&scoped=true"
import script from "./SendTestModal.vue?vue&type=script&lang=js"
export * from "./SendTestModal.vue?vue&type=script&lang=js"

import "./SendTestModal.vue?vue&type=style&index=0&id=0d5adfe1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5adfe1"]])

export default __exports__